import type { PropsWithChildren } from 'react';
import { cn } from '@lib/utils/cn';

type Tone =
  | 'default'
  | 'brand'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'accent'
  | 'neutral';

const toneClasses: Record<Tone, string> = {
  default: 'bg-bg-muted text-fg-muted',
  brand: 'bg-brand-muted text-brand',
  success: 'bg-success-muted text-success',
  warning: 'bg-warning-muted text-warning',
  danger: 'bg-danger-muted text-danger',
  info: 'bg-info-muted text-info',
  accent: 'bg-accent-muted text-accent',
  neutral: 'bg-bg-muted text-fg-muted',
};

export function Badge({
  tone = 'default',
  className,
  children,
}: PropsWithChildren<{ tone?: Tone; className?: string }>) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium',
        toneClasses[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
